<div *ngIf="apiService.supplierRole"
  style="text-align: center;margin-top: 15px;font-size: 20px;color: #978B7F;margin-top: 75px;">
  {{apiService.Notautorized}}
</div>
<div *ngIf="!apiService.supplierRole">
<div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
  <div id="Noprop" class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0" style="margin-bottom: 0px !important;">
    <div class="d-flex align-items-center m-0 pb-1">
      <div class="col-4 pl-0"></div>
      <div class="center col-4 text-center"> <img src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png" style="max-width: 40%;" alt="edit"></div>

      <div class="col-4 text-right">
        <div> <app-helpsection></app-helpsection></div>

      </div>
        </div>
      </div>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
    <app-suppliertab></app-suppliertab>

    <div class="m-0 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">Company</h4>
      </div>

      <div class="col-order-1" style="height: 50px;">
        <button type="button" class="btn btn-custom btn-purple choose_file mx-4" *ngIf="superUserShow" data-toggle="modal" data-target="#showImportAlcorBatch" (click)="onImportAlcorClick()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (onImportAlcorClick())">
          Upload Alcor Batch
        </button>
        <button type="button" class="btn btn-custom btn-purple choose_file mx-4" *ngIf="superUserShow" data-toggle="modal" data-target="#showImportDUNSBatch" (click)="onImportDUNSClick()"> Upload DUNS Batch
        </button>
        <button type="button" (click)="getSupplierActivity()" data-toggle="modal" data-target="#activityCompanySelect" class="btn btn-custom btn-purple choose_file mx-4" *ngIf="superUserShow">
          Update TAX Identifier Batch
        </button>
      </div>
    </div>

    <div class="m-0 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">Site</h4>
      </div>

      <div class="col-order-1" style="height: 50px;">
        <button type="button" class="btn btn-custom btn-purple choose_file mx-4" *ngIf="superUserShow" (click)="onImportBvdIdBatchClick()" data-toggle="modal" data-target="#showImportBvdIdBatch" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (onImportBvdIdBatchClick())">
          Import BVD ID Batch
        </button>
        <button type="button" class="btn btn-custom btn-purple choose_file mx-4" *ngIf="superUserShow" (click)="onImportSaerClick()" data-toggle="modal" data-target="#showImportSAERSupplierBatch">
          Update SAER Batch
        </button>
        <button type="button" class="btn btn-custom btn-purple choose_file mx-4" *ngIf="superUserShow" (click)="onImportLatamClick()" data-toggle="modal" data-target="#showImportLATAMSupplierBatch">
          Import LATAM Batch
        </button>
        <button type="button" class="btn btn-custom btn-purple choose_file mx-4" *ngIf="superUserShow" (click)="onImportRNAIPLClick()" data-toggle="modal" data-target="#showImportRNAIPLSupplierBatch">
          Import RNAIPL Batch
        </button>
      </div>
    </div>
    <div class="m-0 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">Contacts</h4>
      </div>
      <div class="col-order-1" style="height: 50px;">
        <button type="button" class="btn btn-custom btn-purple mx-4" *ngIf="superUserShow" (click)="onImportContactsClick()" data-toggle="modal" data-target="#showImportContactsBatch" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (onImportContactsClick())">  Upload Contacts Batch </button>
      </div>
    </div>
  </section>
</div>
<div class="modal fade mt-4" id="activityCompanySelect" tabindex="-1" role="dialog" aria-labelledby="activityCompanySelectLabel">
  <div class="modal-dialog modal-custom"  role="document">
    <div class="modal-content" style="width: 400px;margin-left: -30% !important;">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="activityCompanySelectLabel">
          Company Selection
          <button type="button" class="close" id="closeEditActivity" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>
      <div *ngIf="activityLoaded" class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 section-scroll">
        <div class="row m-0 pt-5" >
          <div *ngIf="updateTaxStarted">
            <label class="label-control fontBold pb-2 ">Company Selected: {{AvalueSelected[0]}}</label>
            <div> No of Imports in error : {{noOfTaxinError}}</div>

            <div>{{ImportTAxDisplayMsg}}</div>
            <div>{{TextForCompleteUploadTax}}</div>

            <div class="py-2" *ngIf="showDownloadLogForTaxBatch==true">
              <button class="btn btn-custom btn-blue btn-tax" (click)="downloadLogFileForImportTaxBatch()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (downloadLogFileForImportTaxBatch())">
                Download Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-darkblue" *ngIf="showSessionTimeoutTaxBatch"> Waiting for Session Re-authentication to continue importing</span>
            </div>
            </div>
         <div   *ngIf="!updateTaxStarted" style="padding-left: 20px; height: 190px;">
          <label class="label-control fontBold pb-2 weight-font"> A</label>

          <ng-container *ngIf="optActivityA">
             <div style="padding-left: 2px ;" *ngFor="let valueA of optActivityA" >
                <input type="radio" name="radioGroup" [value]="valueA" (click)="getSelectedValue(valueA)" (keydown)="$event.key === 'Enter' && getSelectedValue(valueA)">
                {{valueA.value}}
              </div>
          </ng-container>
          </div>
        </div>
        </div>
        <div *ngIf="!activityLoaded" style="text-align: center;">
          <img src="assets/images/loading.gif" alt="loading...">
        </div>
      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0"  >
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> close </button>
        <ng-container *ngIf="!updateTaxStarted">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateTaxidentifier()" [disabled]="!CompanySelected" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (updateTaxidentifier())">
            <mat-icon svgIcon="mail" class="img-btn mr-2" style="color:white;max-width: 16px;height: 16px;padding-top: 2px;"></mat-icon> <span class="float-right" style="padding-top: 2px;">Save</span>
          </button>
        </ng-container>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showCpyAlcorBatch" tabindex="-1" role="dialog" aria-labelledby="showCpyAlcorBatchLabel">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="showCpyAlcorBatchLabel">
          Company ALCOR batch
          <button type="button" class="close" id="closeCpyAlcorBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2">&nbsp;
              <span [innerHtml]="aliasTextDispCpyAlcor">
              </span>
            </div>
            <div class="py-2">
              <span class="label-darkblue">Processing page:</span>&nbsp;<span style="color: blue;">{{pageCpyAlcorBatchNo}}</span>
            </div>
            <div>
              <mat-progress-bar mode="determinate"
              style="background-color: grey;"
              [value]="progressForCpyAlcor"></mat-progress-bar>

            </div>
          </div>

        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-blue" (click)="cancelCpyAlcorProcessing=true" data-dismiss="modal" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (cancelCpyAlcorProcessing=true)">{{cpyBatchBtn}} </button>
        </section>
      </div>
    </div>
  </div>
</div>



<div style="display: none;">
  <table id="excelTableLogForImportSaerBatch">
    <thead>
      <tr>
        <th>Error Message</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of errorMessArrImportSaerBatch">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div style="display: none;">
  <table id="excelTableLogForImportLatamBatch">
    <thead>
      <tr>
        <th>Error Message</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of errorMessArrImportLatamBatch">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div style="display: none;">
  <table id="excelTableLogForImportRNAIPLBacth">
    <thead>
      <tr>
        <th>Error Message</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of errorMessArrImportRNAIPLBacth">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div style="display: none;">
  <table id="excelTableLogForImportAlcorBatch">
    <thead>
      <tr>
        <th>Error Message</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of errorMessArrImportAlcorBatch">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>



<div style="display: none;">
  <table id="excelTableLogForLogOfImportAlcorBatch">
    <thead>
      <tr>
        <th>Complete Log:</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of logOfImportAlcorBatch">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div style="display: none;">
  <table id="excelTableLogForLogOfImportSaerBatch">
    <thead>
      <tr>
        <th>Complete Log:</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of logOfImportSaerrBatch">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div style="display: none;">
  <table id="excelTableLogForLogOfImportLatamBatch">
    <thead>
      <tr>
        <th>Complete Log:</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of logOfImportLatamBatch">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div style="display: none;">
  <table id="excelTableLogForLogOfImportRNAIPLBacth">
    <thead>
      <tr>
        <th>Complete Log:</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of logOfImportRNAIPLBacth">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>



<div style="display: none;">
  <table id="excelTableLogForImportDUNSBatch">
    <thead>
      <tr>
        <th>Error Message</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of errorMessArrImportDUNSBatch">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>


<div style="display: none;">
  <table id="excelTableLogForImportTaxBatch">
    <thead>
      <tr>
        <th>company Id</th>
        <th>Site Id</th>
        <th>Bvd Id</th>
        <th>Log Message</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of errorMessArrImportTaxBatch">
        <td>
          {{indexRow['CompanyId'] ? indexRow['CompanyId'] : '-'}}
        </td>
        <td>
          {{indexRow['siteId'] ? indexRow['siteId'] : '-'}}
        </td>
        <td>
          {{indexRow['Bvdid'] ? indexRow['Bvdid'] : '-'}}
        </td>
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>



<div style="display: none;">
  <table id="excelTableLogForLogOfImportDUNSBatch">
    <thead>
      <tr>
        <th>Complete Log:</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of logOfImportDUNSBatch">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>



<div style="display: none;">
  <table id="excelTableLogForImportContactsBatch">
    <thead>
      <tr>
        <th>Complete Log:</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of errorMessArrImportContactsBatch">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>



<div style="display: none;">
  <table id="excelTableLogForLogOfImportContactsBatch">
    <thead>
      <tr>
        <th>Complete Log:</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of logOfImportContactsBatch">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal fade" id="showImportLATAMSupplierBatch" tabindex="-1" role="dialog" aria-labelledby="showImportLATAMSupplierBatchLabel">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="showImportLATAMSupplierBatchLabel">
          Import Latam Batch
          <button type="button" class="close" id="closeImportLatamSupplierBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="inputFileVisibleForImportLatam">
              <label for="file" class="label-control font-weight-bold" style="display: block;">Upload XLSX File <span class="element_astrick">*</span></label>
              <input #inputUploads
                    id="fileBatchs"
                    (change)="changeImportLatamSupplierBatch($event)"
                    type="file"
                    accept=".xlsx"  />
              <div style="color: #cb4b32;" *ngIf="uploadDocError">Only XLSX files are accepted</div>
            </div>
            <div class="py-2" *ngIf="showDownloadLogForLatamBatch==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForImportSupplierLatamBatch()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (downloadLogFileForImportSupplierLatamBatch())">
                Download Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForCompleteUploadImportLatam}}</span>
              <span *ngIf="showDownloadLogForLatamBatch==false && inputFileVisibleForImportLatam==false" [innerHtml]="loadingText"></span>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForLatamInError}}</span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" *ngIf="showDownloadLogForLatamBatch==true"> Close </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showImportRNAIPLSupplierBatch" tabindex="-1" role="dialog" aria-labelledby="showImportRNAIPLSupplierBatchLabel">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="showImportRNAIPLSupplierBatchLabel">
          Import RNAIPL Batch
          <button type="button" class="close" id="closeImportRNAIPLSupplierBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="inputFileVisibleForImportRNAIPL">
              <label for="file" class="label-control font-weight-bold" style="display: block;">Upload XLSX File <span class="element_astrick">*</span></label>
              <input #inputUploads
                    id="fileBatchs"
                    (change)="changeImportRNAIPLSupplierBatch($event)"
                    type="file"
                    accept=".xlsx"  />
              <div style="color: #cb4b32;" *ngIf="uploadDocError">Only XLSX files are accepted</div>
            </div>
            <div class="py-2" *ngIf="showDownloadLogForRNAIPLBacth==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForImportSupplierRNAIPLBacth()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (downloadLogFileForImportSupplierRNAIPLBacth())">
                Download Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForCompleteUploadImportRNAIPL}}</span>
              <span *ngIf="showDownloadLogForRNAIPLBacth==false && inputFileVisibleForImportRNAIPL==false" [innerHtml]="loadingText"></span>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForRNAIPLError}}</span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" *ngIf="showDownloadLogForRNAIPLBacth==true"> Close </button>
        </section>
      </div>
    </div>
  </div>
</div>

 <div class="modal fade" id="showImportSAERSupplierBatch" tabindex="-1" role="dialog" aria-labelledby="showImportSAERSupplierBatchLabel">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="showImportSAERSupplierBatchLabel">
          Import SAER Batch
          <button type="button" class="close" id="closeImportSAERSupplierBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="inputFileVisibleForImportSaer">
              <label for="file" class="label-control font-weight-bold" style="display: block;">Upload XLSX File <span class="element_astrick">*</span></label>
              <input #inputUploads
                    id="fileBatchs"
                    (change)="changeImportSaerSupplierBatch($event)"
                    type="file"
                    accept=".xlsx"  />
              <div style="color: #cb4b32;" *ngIf="uploadDocError">Only XLSX files are accepted</div>
            </div>
            <div class="py-2" *ngIf="showDownloadLogForSaerBatch==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForImportSupplierSaerBatch()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (downloadLogFileForImportSupplierSaerBatch())">
                Download Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForCompleteUploadImportSaer}}</span>
              <span *ngIf="showDownloadLogForSaerBatch==false && inputFileVisibleForImportSaer==false" [innerHtml]="loadingText"></span>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForSaerInError}}</span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" *ngIf="showDownloadLogForSaerBatch==true"> Close </button>
        </section>
      </div>
    </div>
  </div>
</div>



 <div class="modal fade" id="showImportAlcorBatch" tabindex="-1" role="dialog" aria-labelledby="showImportAlcorBatchLabel">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="showImportAlcorBatchLabel">
          Import ALCOR Batch
          <button type="button" class="close" id="closeImportAlcorBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="inputFileVisibleForImportAlcor">
              <label for="file" class="label-control font-weight-bold" style="display: block;">Upload XLSX File <span class="element_astrick">*</span></label>
              <input #inputUploads
                    id="fileBatchs"
                    (change)="changeImportAlcorBatch($event)"
                    type="file"
                    accept=".xlsx"  />
              <div style="color: #cb4b32;" *ngIf="uploadDocError">Only XLSX files are accepted</div>
            </div>
            <div class="py-2" *ngIf="showDownloadLogForAlcorBatch==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForImportAlcorBatch()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (downloadLogFileForImportAlcorBatch())">
                Download Log File
              </button>
            </div>

            <div class="py-2">
              <span class="label-darkblue">{{TextForCompleteUploadImportAlcor}}</span>
              <span *ngIf="showDownloadLogForAlcorBatch==false && inputFileVisibleForImportAlcor==false" [innerHtml]="loadingText"></span>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForAlcorInError}}</span>
            </div>
                        <div class="py-2">
              <span class="label-darkblue" *ngIf="showSessionTimeoutAlcorBatch"> Waiting for Session Re-authentication to continue importing</span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" *ngIf="showDownloadLogForAlcorBatch==true"> Close </button>
        </section>
      </div>
    </div>
  </div>
</div>



 <div class="modal fade" id="showImportContactsBatch" tabindex="-1" role="dialog" aria-labelledby="showImportContactsBatchLabel">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="showImportContactsBatchLabel">
          Upload Contacts Batch
          <button type="button" class="close" id="closeImportContactsBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="inputFileVisibleForImportContacts">
              <label for="file" class="label-control font-weight-bold" style="display: block;">Upload XLSX File <span class="element_astrick">*</span></label>
              <input #inputUploads
                    id="fileBatchs"
                    (change)="changeImportContactsBatch($event)"
                    type="file"
                    accept=".xlsx"  />
              <div style="color: #cb4b32;" *ngIf="uploadDocError">Only XLSX files are accepted</div>
            </div>
            <div class="py-2" *ngIf="showDownloadLogForContactsBatch==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForImportContactsBatch()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (downloadLogFileForImportContactsBatch())">
                Download Log File
              </button>
            </div>
            <div class="py-2" *ngIf="showDownloadLogForContactsBatchComplete==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForLogOfImportContactsBatch()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (downloadLogFileForLogOfImportContactsBatch())">
                Download Complete Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForCompleteUploadImportContacts}}</span>
              <span *ngIf="showDownloadLogForContactsBatch==false && inputFileVisibleForImportContacts==false" [innerHtml]="loadingText"></span>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForContactsInError}}</span>
            </div>
                        <div class="py-2">
              <span class="label-darkblue" *ngIf="showSessionTimeoutContactsBatch"> Waiting for Session Re-authentication to continue importing</span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" *ngIf="showDownloadLogForContactsBatch==true"> Close </button>
        </section>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="showImportDUNSBatch" tabindex="-1" role="dialog" aria-labelledby="showImportDUNSBatchLabel">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="showImportDUNSBatchLabel">
          Upload DUNS Batch
          <button type="button" class="close" id="closeImportDUNSBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="inputFileVisibleForImportDUNS">
              <label for="file" class="label-control font-weight-bold" style="display: block;">Upload XLSX File <span class="element_astrick">*</span></label>
              <input #inputUploads
                    id="fileBatchs"
                    (change)="changeUploadDUNSBatch($event)"
                    type="file"
                    accept=".xlsx"  />
              <div style="color: #cb4b32;" *ngIf="uploadDocError">Only XLSX files are accepted</div>
            </div>
            <div class="py-2" *ngIf="showDownloadLogForDUNSBatch==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForImportDUNSBatch()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (downloadLogFileForImportDUNSBatch())">
                Download Log File
              </button>
            </div>
            <div class="py-2" *ngIf="showDownloadLogForDUNSBatchComplete==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForLogOfImportDUNSBatch()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (downloadLogFileForLogOfImportDUNSBatch())">
                Download Complete Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForCompleteUploadDUNS}}</span>
              <span *ngIf="showDownloadLogForDUNSBatch==false && inputFileVisibleForImportDUNS==false" [innerHtml]="loadingText"></span>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForDUNSInError}}</span>
            </div>
            <div class="py-2">
              <span class="label-darkblue" *ngIf="showSessionTimeoutDUNSBatch"> Waiting for Session Re-authentication to continue importing</span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" *ngIf="showDownloadLogForDUNSBatch==true"> Close </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showImportBvdIdBatch" tabindex="-1" role="dialog" aria-labelledby="showImportBvdIdBatchLabel">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="showImportBvdIdBatchLabel">
          Import BVD ID Batch
          <button type="button" class="close" id="closeImportBvdIdBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="inputFileVisibleForImportBvdId">
              <label for="file" class="label-control font-weight-bold" style="display: block;">Upload XLS File <span class="element_astrick">*</span></label>
              <input #inputUploads
                    id="fileBvdIdBatch"
                    (change)="changeImportBvdIdBatch($event)"
                    type="file"
                    accept=".xls,.xlsx"  />
              <div style="color: #cb4b32;" *ngIf="uploadBvdIdDocError">Only XLS/XLSX files are accepted</div>
            </div>
            <div class="py-2" *ngIf="showDownloadLogForBvdIdBatch==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForImportBvdIdBatch()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (downloadLogFileForImportBvdIdBatch())">
                Download Log File
              </button>
            </div>

            <div class="py-2">
              <span class="label-darkblue">{{TextForCompleteUploadImportBvdId}}</span>
              <span *ngIf="showDownloadLogForBvdIdBatch==false && inputFileVisibleForImportBvdId==false" [innerHtml]="loadingText"></span>
            </div>
            <div class="py-2">
              <span class="label-darkblue">{{TextForBvdIdInError}}</span>
            </div>
            <div class="py-2" *ngIf="displayMessage!=''">
              <span class="label-darkblue">{{displayMessage}}</span>
            </div>
            <div class="py-2">
              <span class="label-darkblue" *ngIf="showSessionTimeoutBvdIdBatch"> Waiting for Session Re-authentication to continue importing</span>
            </div>
            <div class="py-2" *ngIf="currentBvdIdProcessing">
              <span class="label-darkblue" >Processing BVD ID: {{currentBvdIdProcessing}}</span>&nbsp;<span style="color: blue;" >{{currentBvdIdProcessingIndex}} / {{totalBvdIdsToProcess}}</span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" *ngIf="showDownloadLogForBvdIdBatch==true"> Close </button>
          <button type="button" class="btn btn-custom btn-blue" (click)="stopBvdIdBatch()" *ngIf="bvdIdBatchIsRunning"> Stop </button>
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" *ngIf="!bvdIdBatchIsRunning"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>



<div style="display: none;">
  <button id="btnForGRContinue" data-target="#showAlreadyRunBatch" data-toggle="modal"></button>
  <button id="btnForGRBatch" data-target="#showGRBatch" data-toggle="modal"></button>
  <button id="BtnForshowConfirmStartBatchOnStart" data-target="#showConfirmStartBatchOnStart" data-toggle="modal"></button>
  <button id="btnForSelectCountryId" data-target="#showSelectCountryId" data-toggle="modal"></button>
  <button id="btnForHQContinue" data-target="#showAlreadyRunBatchForCpyHq" data-toggle="modal"></button>
  <button id="btnForHQStart" data-target="#showCpyHQBatch" data-toggle="modal"></button>
  <button id="btnForHQCheckOnStart" data-target="#showConfirmStartBatchForCpyHq" data-toggle="modal"></button>
  <button id="btnForSiteContinue" data-target="#showAlreadyRunBatchForSiteAss" data-toggle="modal"></button>
  <button id="btnForSiteAssignmentBatch" data-target="#showSiteAssnBatch" data-toggle="modal"></button>
  <button id="BtnForshowConfirmStartBatchOnStartForSiteAss" data-target="#showConfirmStartBatchOnStartForSiteAss" data-toggle="modal"></button>
  <button id="btnForShowNissanCodeUploading" data-target="#showNissanCodeUploading" data-toggle="modal"></button>
  <button id="btnForMainEntrContinue" data-target="#showAlreadyRunMainEntrBatch" data-toggle="modal"></button>
  <button id="btnForMainEntrBatch" data-target="#showMainEntrBatch" data-toggle="modal"></button>
  <button id="BtnForshowConfirmMainEntrStartBatch" data-target="#showConfirmMainEntrStartBatch" data-toggle="modal"></button>
  <button id="btnForImportSaerBatch" data-target="#showImportSAERSupplierBatch" data-toggle="modal"></button>
  <button id="btnForImportAlcorBatch" data-target="#showImportAlcorBatch" data-toggle="modal"></button>
  <button id="btnForImportLatamBatch" data-target="#showImportLATAMSupplierBatch" data-toggle="modal"></button>
  <button id="btnForImportRNAIPLBatch" data-target="#showImportRNAIPLSupplierBatch" data-toggle="modal"></button>
  <button id="btnForImportContactsBatch" data-target="#showImportContactsBatch" data-toggle="modal"></button>
  <button id="btnForImportBvdIdBatch" data-target="#showImportBvdIdBatch" data-toggle="modal"></button>
  <button id="btnForImportDUNSBatch" data-target="#showImportDUNSBatch" data-toggle="modal"></button>
  <button id="btnForImportTaxBatch" data-target="#activityCompanySelect" data-toggle="modal"></button>
  <button id="btnForErrorRefresh" data-target="#showErrorRefresh" data-toggle="modal"></button>
</div>
</div>